module.exports = {"headerTitle":"Import subjektov","headerTitleResults":"Výsledok importu subjektov","close":"Zrušiť","ok":"OK"}